<template lang="pug">
.TrialCompletePage
  km-character(:message="message")
  .content(ref="content")
    .inner(ref="inner")
      .certificate
        .name {{account.name ? account.name : 'ゲスト'}} 殿
        .background
          img(src="@/assets/certificate_trial.png" width="" alt="")
      .message
        .title 体験版クリアおめでとうございます！
        .body
          | 体験版ではここまでとなります。<br>
          | ブラインドタッチの手応えを感じてもらえたでしょうか？<br>
          | 製品版では全てのキーを使ったブラインドタッチの習得を目指すことができます。<br>
          | ぜひお試しください。
        .fullVersionIntro
          img(src="@/assets/full_thumb_sample_1.png" alt="")
          img(src="@/assets/full_thumb_sample_2.png" alt="")
          img(src="@/assets/full_thumb_sample_3.png" alt="")
          img(src="@/assets/full_thumb_sample_4.png" alt="")
        .notice ※画面は開発中の内容です

  km-footer.footer(
    title="体験版クリア！"
    subTitle=""
    :navigationDisabled="true"
    @onBackButtonClick=""
  )
  transition(name="fade")
    km-inline-frame-modal(
      v-show="promotionModalEnabled"
      src="/app/static/html/promotion.html"
      @onClose="handleInlineFrameModalClose"
    )
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Character from '@/components/shared/Character'
import InlineFrameModal from '@/components/shared/InlineFrameModal'
import * as constants from '@/constants'

export default {
  name: 'trial-complete-page',
  components: {
    'km-character': Character,
    'km-inline-frame-modal': InlineFrameModal
  },
  props: {
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      constants,
      promotionModalEnabled: false,
      message: ''
    }
  },
  computed: {
    ...mapState('User', {
      rank: state => state.rank,
      lvl: state => state.lvl,
      exp: state => state.exp,
      progress: state => state.progress,
      point: state => state.point,
      account: state => state.account,
      challengeResult: state => state.challenge_result
    })
  },
  methods: {
    ...mapActions('Sound', ['playBGM', 'stopBGM']),
    handleInlineFrameModalClose() {
      this.promotionModalEnabled = false
    },
  },
  mounted() {
    if (this.embedded) {
      setTimeout(() => {
        this.promotionModalEnabled = true
      }, 6000)
    }
    this.playBGM('bgmCongrats')
    this.message = 'いかがでしたか。またお会いできるといいですね！'
  }
}
</script>

<style lang="scss" scoped>
.TrialCompletePage {
  width: 100%;
  height: 100%;
  background: #f5f2e9;
}

.content {
  width: 100%;
  height: 100%;
  overflow: scroll;

  .inner {
    display: flex;
    height: calc(100% - 80px);
    text-align: center;
  }
}

.certificate {
  position: relative;
  transform: rotate(-30deg) scale(1.5);
  filter: blur(10px);
  opacity: 0;
  animation-name: appear;
  animation-duration: 1s;
  animation-delay: 1s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;

  @keyframes appear {
    0% {
      opacity: 0;
      filter: blur(5px);
      transform: rotate(-10deg) scale(0.5);
    }

    100% {
      opacity: 1;
      filter: blur(0);
      transform: rotate(0deg) scale(1);
    }
  }

  .name {
    position: absolute;
    top: 300px;
    left: 10%;
    width: 80%;
    font-size: 3rem;
    text-align: center;
    z-index: 1;
  }

  .background {
    img {
      width: 481px;
      height: 680px;
    }
  }
}

.message {
  padding: 60px 30px;

  opacity: 0;
  transform: translateX(30px);

  animation-name: messageAppear;
  animation-duration: 1.5s;
  animation-delay: 2.5s;
  animation-timing-function: ease;
  animation-fill-mode: forwards;

  @keyframes messageAppear {
    0% {
      opacity: 0;
      transform: translateX(30px);
    }

    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .title {
    margin: 0 0 30px 0;
    color: orange;
    text-align: left;
    font-size: 4rem;
  }

  .body {
    margin: 0 auto 30px;
    text-align: left;
    font-size: 2rem;
  }

  .fullVersionIntro {
    width: 60%;
    text-align: left;
    img {
      width: 50%;
    }
  }

  .notice {
    text-align: left;
    font-size: 1.2rem;
  }
}

.footer {
  position: absolute;
  bottom: 0;
}
</style>
